import { render, staticRenderFns } from "./TutorInfocertSign.vue?vue&type=template&id=9717f06e&scoped=true&"
import script from "./TutorInfocertSign.vue?vue&type=script&lang=js&"
export * from "./TutorInfocertSign.vue?vue&type=script&lang=js&"
import style0 from "./TutorInfocertSign.vue?vue&type=style&index=0&id=9717f06e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9717f06e",
  null
  
)

export default component.exports